<template>
    <div class="social-sticky social-sticky-bgdark-colorwhite">
        <span v-for="(social,index) in socials"
              class="link-icon social-sticky-item"
              :class="index"
              :title="social"
              @click="share(index)">

            <i class="transition "
               :class=" classes[index] "
               :title='social'
            >
            </i>
        </span>
    </div>
</template>

<script>
  export default {
    name: "share-buttons",
    data() {
      return {
          socials: {
              // facebook: 'facebook',
              telegram: 'telegram',
              whatsapp: 'whatsApp',
              vk: 'vk',
              // twitter: 'twitter',
              // gPlus: 'google plus',
          },
          links: {
              // facebook: 'https://www.facebook.com/sharer/sharer.php?u={0}',
              telegram: 'https://t.me/share/url?url={0}&text={1}',
              whatsapp: 'https://api.whatsapp.com/send?text={1}{0}',
              // twitter: 'https://twitter.com/intent/tweet?text={1}&url={0}&related=',
              // gPlus: 'https://plus.google.com/share?url={0}&text={1}',
              vk: 'https://vk.com/share.php?url={0}',
          },
          classes: {
              // youtube: 'youtube',
              // facebook: 'facebook',
              // instagram: 'instagram',
              telegram: 'telegram',
              whatsapp: 'whatsapp',
              // twitter: 'twitter',
              vk: 'vk',
          },
      }
    },
    methods: {
      share(type) {
        let title = document.title.replace('|', ' ') + ' ';

        let str = this.links[type].format(location, title);

        this.showPopup(str);
      },
      showPopup(url) {
        let windowWidth = 600;
        let windowHeight = 400;

        let dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : window.screenX;
        let dualScreenTop = window.screenTop != undefined ? window.screenTop : window.screenY;

        let width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
        let height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

        let systemZoom = width / window.screen.availWidth;
        let left = (width - windowWidth) / 2 / systemZoom + dualScreenLeft;
        let top = (height - windowHeight) / 2 / systemZoom + dualScreenTop;

        let windowFormat = 'scrollbars=yes,width={0},height={1},top={2},left={3}'.format(windowWidth, windowHeight, top, left);

        let newWindow = window.open(url, '', windowFormat);

        if (window.focus) {
          newWindow.focus();
        }
      },
    }
  }
</script>




// WEBPACK FOOTER //
// resources/js/components/elements/ShareButtons.vue